
import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {GlobalEventsManager} from '../GlobalEventManager';
import {User} from '../Interfaces/User';
import {ClientRequest} from '../Interfaces/ClientRequest';
import {ListData} from '../Interfaces/ListData';
import {QueryService} from '../Services/query.service';
import {DemurrageLines} from '../Interfaces/DemurrageLines';

@Injectable({
  providedIn: 'root'
})
export class SharedVarService {
  cusSubscription : Subscription;
  private confirmed: BehaviorSubject<boolean>;
  private killSub: BehaviorSubject<boolean>;
  private userName: BehaviorSubject<string>;
  private actionName: BehaviorSubject<string>;
  private year: number;
  private _user: User; subscription: Subscription;
  private gate: string; private _myUser: User;
  private dateOut: Date; private _demurrageLines: DemurrageLines[];
  public countries : {code:string, description:string}[] = [];
  public months : {code:string, description:string}[] = [];
  public cards : {code:string, description:string}[] = [];
  public years : {code:string, description:string}[] = [];
  public states : {code:string, description:string}[] = [];
  public regions : {code:string, description:string}[] = [];
  private clientRequest: ClientRequest;
  private _foundStorageSSL: boolean = false;


  get foundStorageSSL(): boolean {
    return this._foundStorageSSL;
  }

  set foundStorageSSL(value: boolean) {
    this._foundStorageSSL = value;
  }

  get myUser(): User {
    return this._myUser;
  }

  set myUser(value: User) {
    this._myUser = value;
  }

  get demurrageLines(): DemurrageLines[] {
    return this._demurrageLines;
  }

  set demurrageLines(value: DemurrageLines[]) {
    this._demurrageLines = value;
  }

  get user(): User {
    return this._user;
  }

  set user(value: User) {
    this._user = value;
  }

  constructor( private  globalEventsManager: GlobalEventsManager, private queryService: QueryService) {
    this.globalEventsManager.cusSubscription.subscribe((mode: Subscription) => {
      this.cusSubscription = mode;
    });

    this.confirmed = new BehaviorSubject<boolean>(false);
    this.killSub = new BehaviorSubject<boolean>(false);
    this.userName = new BehaviorSubject<string>("");
    this.actionName = new BehaviorSubject<string>(" ");
  }

  checkForSpecialChars(arrayValue: string): boolean{
    var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if(format.test(arrayValue)){
      return false;
    }else{
      return true;
    }
  }


  onlySendOneHundread(arrayIn: string[]) : string[]{
    if (arrayIn.length>99){
      arrayIn = arrayIn.slice(0,100);
    }
    return arrayIn;
  }


  isAStorageSSL(lineId: string): string{
    if (this._myUser.role=="LINEOP"){
      return "L";
    }else{
      if (this._demurrageLines.findIndex(xx=>xx.line_id==lineId)==-1){
          return "N"
      }else{
        this._foundStorageSSL = true;
        return "Y"
      }
    }
  }


  getAllSslStorageCollections(userIn: User) {
    this.clientRequest = {} as ClientRequest;
    this._demurrageLines = [];
    this.clientRequest.user = userIn;

    const lhsUserObs$ = this.queryService.getAllSslStorageCollections(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this._demurrageLines = lstConts;
      },
      error => {

      },
      () => {


      });

  }

  killSubscription(newValue): void {
    this.killSub.next(newValue);
    if (this.cusSubscription!=null){
      this.cusSubscription.unsubscribe();
      this.cusSubscription=null;
    }
  }


  getHideMainMenu(): Observable<boolean> {
    return this.killSub.asObservable();
  }

  setActionName(newValue): void {
    this.actionName.next(newValue);
  }

  setGate(newValue){
    this.gate = newValue;
  }
  getGate(): string{
    return this.gate;
  }


  getActionName(): Observable<string> {
    return this.actionName.asObservable();
  }

  setUsername(newValue): void {
    this.userName.next(newValue);
  }

  getUsername(): Observable<string> {
    return this.userName.asObservable();
  }

  setConfirmed(newValue): void {
    this.confirmed.next(newValue);
  }


  getConfirmed(): Observable<boolean> {
    return this.confirmed.asObservable();
  }





  getMonths(): {code:string, description:string}[]{
    this.months = [];
    this.months.push({"code": '1', "description": 'January'});
    this.months.push({"code": '2', "description": 'February'});
    this.months.push({"code": '3', "description": 'March'});
    this.months.push({"code": '4', "description": 'April'});
    this.months.push({"code": '5', "description": 'May'});
    this.months.push({"code": '6', "description": 'June'});
    this.months.push({"code": '7', "description": 'July'});
    this.months.push({"code": '8', "description": 'August'});
    this.months.push({"code": '9', "description": 'September'});
    this.months.push({"code": '10', "description": 'October'});
    this.months.push({"code": '11', "description": 'November'});
    this.months.push({"code": '12', "description": 'December'});
    return this.months;
  }

  getYears(): {code:string, description:string}[]{
    this.years = [];

    this.dateOut = new Date();
    this.year = this.dateOut.getFullYear();
    var totalNum = this.year + 10;

    for (var xx = this.year; xx<totalNum; xx++){
      this.years.push({"code": xx.toString(), "description": xx.toString()});
    }

    return this.years;
  }


  getCards(): {code:string, description:string}[]{
    this.cards = [];
    this.cards.push({"code": 'American Express', "description": 'American Express'});
    this.cards.push({"code": 'Discover', "description": 'Discover'});
    this.cards.push({"code": 'Mastercard', "description": 'Mastercard'});
    this.cards.push({"code": 'Visa', "description": 'Visa'});
    return this.cards;
  }

  getCountries(): {code:string, description:string}[]{
    this.countries = [];
    this.countries.push({"code": 'US', "description": 'United States'});
    this.countries.push({"code": 'CA', "description": 'Canada'});
    return this.countries;
  }


  getRegions(): {code:string, description:string}[]{
    this.regions = [];
    this.regions.push({"code": 'AB', "description": 'Alberta'});
    this.regions.push({"code": 'BC', "description": 'British Columbia'});
    this.regions.push({"code": 'MB', "description": 'Manitoba'});
    this.regions.push({"code": 'NB', "description": 'New Brunswick'});
    this.regions.push({"code": 'NL', "description": 'Newfoundland/Labrador'});
    this.regions.push({"code": 'NT', "description": 'Northwest Territories'});
    this.regions.push({"code": 'NS', "description": 'Nova Scotia'});
    this.regions.push({"code": 'NU', "description": 'Nunavut'});
    this.regions.push({"code": 'ON', "description": 'Ontario'});
    this.regions.push({"code": 'PE', "description": 'Prince Edward Island'});
    this.regions.push({"code": 'QC', "description": 'Quebec'});
    this.regions.push({"code": 'SK', "description": 'Saskatchewan'});
    this.regions.push({"code": 'YT', "description": 'Yukon'});
    return this.regions;
  }

  getStates(): {code:string, description:string}[]{
    this.states = [];
    this.states.push({"code": 'AL', "description": 'Alabama'});
    this.states.push({"code": 'AK', "description": 'Alaska'});
    this.states.push({"code": 'AZ', "description": 'Arizona'});
    this.states.push({"code": 'AR', "description": 'Arkansas'});
    this.states.push({"code": 'CA', "description": 'California'});
    this.states.push({"code": 'CO', "description": 'Colorado'});
    this.states.push({"code": 'CT', "description": 'Connecticut'});
    this.states.push({"code": 'DE', "description": 'Delaware'});
    this.states.push({"code": 'DC', "description": 'District of Columbia'});
    this.states.push({"code": 'FL', "description": 'Florida'});
    this.states.push({"code": 'GA', "description": 'Georgia'});
    this.states.push({"code": 'HI', "description": 'Hawaii'});
    this.states.push({"code": 'ID', "description": 'Idaho'});
    this.states.push({"code": 'IL', "description": 'Illinois'});
    this.states.push({"code": 'IN', "description": 'Indiana'});
    this.states.push({"code": 'IA', "description": 'Iowa'});
    this.states.push({"code": 'KS', "description": 'Kansas'});
    this.states.push({"code": 'KY', "description": 'Kentucky'});
    this.states.push({"code": 'LA', "description": 'Louisiana'});
    this.states.push({"code": 'ME', "description": 'Maine'});
    this.states.push({"code": 'MD', "description": 'Maryland'});
    this.states.push({"code": 'MA', "description": 'Massachusetts'});
    this.states.push({"code": 'MI', "description": 'Michigan'});
    this.states.push({"code": 'MN', "description": 'Minnesota'});
    this.states.push({"code": 'MS', "description": 'Mississippi'});
    this.states.push({"code": 'MO', "description": 'Missouri'});
    this.states.push({"code": 'MT', "description": 'Montana'});
    this.states.push({"code": 'NE', "description": 'Nebraska'});
    this.states.push({"code": 'NV', "description": 'Nevada'});
    this.states.push({"code": 'NH', "description": 'New Hampshire'});
    this.states.push({"code": 'NJ', "description": 'New Jersey'});
    this.states.push({"code": 'NM', "description": 'New Mexico'});
    this.states.push({"code": 'NY', "description": 'New York'});
    this.states.push({"code": 'NC', "description": 'North Carolina'});
    this.states.push({"code": 'ND', "description": 'North Dakota'});
    this.states.push({"code": 'OH', "description": 'Ohio'});
    this.states.push({"code": 'OK', "description": 'Oklahoma'});
    this.states.push({"code": 'OR', "description": 'Oregon'});
    this.states.push({"code": 'PA', "description": 'Pennsylvania'});
    this.states.push({"code": 'PR', "description": 'Puerto Rico'});
    this.states.push({"code": 'RI', "description": 'Rhode Island'});
    this.states.push({"code": 'SC', "description": 'South Carolina'});
    this.states.push({"code": 'SD', "description": 'South Dakota'});
    this.states.push({"code": 'TN', "description": 'Tennessee'});
    this.states.push({"code": 'TX', "description": 'Texas'});
    this.states.push({"code": 'UT', "description": 'Utah'});
    this.states.push({"code": 'VT', "description": 'Vermont'});
    this.states.push({"code": 'VI', "description": 'US Virgin Islands'});
    this.states.push({"code": 'VA', "description": 'Virginia'});
    this.states.push({"code": 'WA', "description": 'Washington'});
    this.states.push({"code": 'WV', "description": 'West Viginia'});
    this.states.push({"code": 'WI', "description": 'Wisconsin'});
    this.states.push({"code": 'WY', "description": 'Wyoming'});
    return this.states;
  }


}


